import { Post } from '@/mocks/posts';
import PostCard from '@/components/base/PostCard';
import AdSlot from './AdSlot';

interface PostGridProps {
  posts: Post[];
  title?: string;
}

export default function PostGrid({ posts, title }: PostGridProps) {
  if (posts.length === 0) {
    return (
      <div className="text-center py-16 text-stone-400">
        <i className="ri-article-line text-4xl mb-3 block" />
        <p className="text-sm">No posts published yet. Check back soon!</p>
      </div>
    );
  }

  return (
    <section>
      {title && (
        <h2 className="text-xl font-bold text-stone-800 mb-6 pb-3 border-b border-stone-100">
          {title}
        </h2>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {posts.map((post, index) => (
          <>
            <PostCard key={post.id} post={post} />
            {/* Insert ad after every 6th post */}
            {(index + 1) % 6 === 0 && index !== posts.length - 1 && (
              <div key={`ad-${index}`} className="sm:col-span-2 lg:col-span-3">
                <AdSlot slot="in-article" />
              </div>
            )}
          </>
        ))}
      </div>
    </section>
  );
}
